module.exports = __webpack_public_path__ + "static/img/3_1.b9ae20eb.jpg";